module.exports = __webpack_public_path__ + "img/PlatformComposition_Old.476a0794.png";